var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    { staticStyle: { padding: "0" }, attrs: { xs12: "" } },
    [
      _c(
        "v-data-table",
        {
          attrs: {
            headers: _vm.headers,
            items: _vm.items,
            "hide-default-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function ({ item }) {
                return [
                  _c(
                    "tr",
                    { staticClass: "rigaProgresso" },
                    [
                      _c("td", [
                        item.ddtResoData
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("formatDate")(item.ddtResoData))
                              ),
                            ])
                          : item.dataElaborazione
                          ? _c(
                              "div",
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c("v-icon", _vm._g({}, on), [
                                                _vm._v("mdi-information"),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Data sincronizzazione della spedizione da As-400"
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        item.dataElaborazione
                                      )
                                    ) +
                                    " "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._l(item.values, function (value, index) {
                        return _c(
                          "td",
                          { key: "prog_" + value.id + "_" + index },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(value > 0 ? value : "&nbsp;"),
                              },
                            }),
                          ]
                        )
                      }),
                      _c(
                        "td",
                        [
                          item.ddt
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    href: `/ddt/${item.ddt}`,
                                    target: "_blank",
                                  },
                                },
                                [_c("v-icon", [_vm._v("assignment")])],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "no-data" },
            [
              _c("v-alert", { attrs: { value: true, type: "info" } }, [
                _vm._v(" Le lavorazioni non sono ancora state spedite. "),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }